import styled from 'styled-components';

import { BaseStyledComponentProps } from '../../../../utils/styles-constants';

interface StyledButtonProps extends BaseStyledComponentProps {
	isActive: boolean;
	isAscending: boolean;
	disabled: boolean;
}

const StyledButton = styled('button')`
	display: flex;
	align-items: center;
	padding: 4px;
	padding-left: 0;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 11px;
	line-height: 12px;
	background-color: transparent;
	color: ${(props: StyledButtonProps) => props.isActive && !props.disabled
		? props.theme.primary.actionColor
		: props.theme.primary.strongColor
	};
	cursor: ${(props: StyledButtonProps) => props.disabled ? 'default' : 'pointer'};

	svg {
		flex: 0 0 auto;
		width: 8px;
		height: 9px;
		margin-left: 5px;
		fill: ${(props: StyledButtonProps) => props.theme.primary.actionColor}

		${(props: StyledButtonProps) => props.isAscending && 'transform: rotate(180deg);'}
	}
`;

export { StyledButton };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/ButtonSort/styles.ts